<template>
  <div class="objectives">
    <!-- <div class="no-print location-info">
        Restaurante
        <span class="location-data">{{selectedLocation.site}} {{selectedLocation.name}}</span>
      </div> -->
    <div class="no-print" ref="priorities">
      <div class="subtitle">{{ $t('general.priorities') }}</div>
      <div class="description">
        {{ $t('marketing.objectives.description') }}
      </div>
      <img class="cover" :src="getMarketingPhoto()" />
      <div class="priority national no-print">
        <div class="title">
          {{ $t('marketing.objectives.national.title') }}
          <!-- <span class="complement">Selecciona 2</span> -->
        </div>
        <div
          v-for="(item, index) in categories"
          :id="item.id"
          v-if="item.type == 1"
          class="option"
          :class="{
            select1: obj1 == item.id,
            select2: obj2 == item.id,
            select3: obj3 == item.id
          }"
          @click="selectNacional(item.name, item.id, 'national')"
        >
          {{ item.name }}
        </div>
        <!-- <div v-for="(item, index) in objectivesOptions" :id="item.id" v-if="item.type==1" class="option" :class="{select1:obj1 == item.id, select2:obj2 == item.id}"  @click="selectNacional(item.name, item.id)">{{item.name}}</div>      -->
      </div>
      <div class="priority local no-print">
        <div class="title">
          {{ $t('marketing.objectives.local.title') }}
          <!-- <span class="complement">Selecciona 1</span> -->
        </div>
        <div
          v-for="(item, index) in categories"
          :id="item.id"
          v-if="item.type == 2"
          class="option"
          :class="{
            select1: obj1 == item.id,
            select2: obj2 == item.id,
            select3: obj3 == item.id
          }"
          @click="selectNacional(item.name, item.id, 'local')"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <div ref="objectives">
      <div class="subtitle">{{ $t('general.objectives') }}</div>

      <table class="objectives-table" cellspacing="20px">
        <thead>
          <tr>
            <th>
              {{ $t('marketing.objectives.priorities.priority.1') }}
              <span class="name">{{ tableData[0].name }}</span>
            </th>
            <th>
              {{ $t('marketing.objectives.priorities.priority.2') }}
              <span class="name">{{ tableData[1].name }}</span>
            </th>
            <th>
              {{ $t('marketing.objectives.priorities.priority.3') }}
              <span class="name">{{ tableData[2].name }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="3" class="separator">
              {{ $t('marketing.objectives.priorities.description') }}
            </td>
          </tr>
          <tr>
            <td :class="{ hidden: obj1 == undefined }">
              <span class="cell-title">{{ $t('time.daypart') }}</span>
              <select
                v-model="tableData[0].daypart.week"
                @change="changeOption()"
              >
                <option value="week">{{ $t('time.week') }}</option>
                <option value="weekend">{{ $t('time.weekend') }}</option>
              </select>
              <select
                v-model="tableData[0].daypart.time"
                @change="changeOption()"
              >
                <option value="manana">{{ $t('time.morning') }}</option>
                <option value="comida">{{ $t('time.lunch') }}</option>
                <option value="tarde">{{ $t('time.afternoon') }}</option>
                <option value="cena">{{ $t('time.evening') }}</option>
                <option value="noche">{{ $t('time.night') }}</option>
                <option value="mananatarde">{{ $t('time.morning_afternoon') }}</option>
                <option value="comidacena">{{ $t('time.lunch_evening') }}</option>
                <option value="allday">{{ $t('time.all_day') }}</option>
              </select>
            </td>
            <td :class="{ hidden: obj2 == undefined }">
              <span class="cell-title">{{ $t('time.daypart') }}</span>
              <select
                v-model="tableData[1].daypart.week"
                @change="changeOption()"
              >
                <option value="week">{{ $t('time.week') }}</option>
                <option value="weekend">{{ $t('time.weekend') }}</option>
              </select>
              <select
                v-model="tableData[1].daypart.time"
                @change="changeOption()"
              >
                <option value="manana">{{ $t('time.morning') }}</option>
                <option value="comida">{{ $t('time.lunch') }}</option>
                <option value="tarde">{{ $t('time.afternoon') }}</option>
                <option value="cena">{{ $t('time.evening') }}</option>
                <option value="noche">{{ $t('time.night') }}</option>
                <option value="mananatarde">{{ $t('time.morning_afternoon') }}</option>
                <option value="comidacena">{{ $t('time.lunch_evening') }}</option>
                <option value="allday">{{ $t('time.all_day') }}</option>
              </select>
            </td>
            <td :class="{ hidden: obj3 == undefined }">
              <span class="cell-title">{{ $t('time.daypart') }}</span>
              <select
                v-model="tableData[2].daypart.week"
                @change="changeOption()"
              >
                <option value="week">{{ $t('time.week') }}</option>
                <option value="weekend">{{ $t('time.weekend') }}</option>
              </select>
              <select
                v-model="tableData[2].daypart.time"
                @change="changeOption()"
              >
                <option value="manana">{{ $t('time.morning') }}</option>
                <option value="comida">{{ $t('time.lunch') }}</option>
                <option value="tarde">{{ $t('time.afternoon') }}</option>
                <option value="cena">{{ $t('time.evening') }}</option>
                <option value="noche">{{ $t('time.night') }}</option>
                <option value="mananatarde">{{ $t('time.morning_afternoon') }}</option>
                <option value="comidacena">{{ $t('time.lunch_evening') }}</option>
                <option value="allday">{{ $t('time.all_day') }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <td :class="{ hidden: obj1 == undefined }">
              <span class="cell-title">{{ $t('marketing.objectives.priorities.priority.behavior.title') }}</span>
              <select v-model="tableData[0].behavior" @change="changeOption()">
                <option value="frecuencia">{{ $t('marketing.objectives.priorities.priority.behavior.frequency') }}</option>
                <option value="ticket">{{ $t('marketing.objectives.priorities.priority.behavior.ticket') }}</option>
                <option value="penetracion"
                  >{{ $t('marketing.objectives.priorities.priority.behavior.penetration') }}</option
                >
              </select>
            </td>
            <td :class="{ hidden: obj2 == undefined }">
              <span class="cell-title">{{ $t('marketing.objectives.priorities.priority.behavior.title') }}</span>
              <select v-model="tableData[1].behavior" @change="changeOption()">
                <option value="frecuencia">{{ $t('marketing.objectives.priorities.priority.behavior.frequency') }}</option>
                <option value="ticket">{{ $t('marketing.objectives.priorities.priority.behavior.ticket') }}</option>
                <option value="penetracion"
                  >{{ $t('marketing.objectives.priorities.priority.behavior.penetration') }}</option
                >
              </select>
            </td>
            <td :class="{ hidden: obj3 == undefined }">
              <span class="cell-title">{{ $t('marketing.objectives.priorities.priority.behavior.title') }}</span>
              <select v-model="tableData[2].behavior" @change="changeOption()">
                <option value="frecuencia">{{ $t('marketing.objectives.priorities.priority.behavior.frequency') }}</option>
                <option value="ticket">{{ $t('marketing.objectives.priorities.priority.behavior.ticket') }}</option>
                <option value="penetracion"
                  >{{ $t('marketing.objectives.priorities.priority.behavior.penetration') }}</option
                >
              </select>
            </td>
          </tr>
          <tr>
            <td :class="{ hidden: obj1 == undefined }">
              <span class="cell-title"
                >{{ $t('marketing.objectives.priorities.priority.main_competitor') }}</span
              >
              <select
                v-model="tableData[0].competence"
                @change="changeOption()"
              >
                <option
                  v-for="item in competenceSelected"
                  :value="item.brand_id"
                  >{{ item.name }}</option
                >
              </select>
            </td>
            <td :class="{ hidden: obj2 == undefined }">
              <span class="cell-title"
                >{{ $t('marketing.objectives.priorities.priority.main_competitor') }}</span
              >
              <select
                v-model="tableData[1].competence"
                @change="changeOption()"
              >
                <option
                  v-for="item in competenceSelected"
                  :value="item.brand_id"
                  >{{ item.name }}</option
                >
              </select>
            </td>
            <td :class="{ hidden: obj3 == undefined }">
              <span class="cell-title"
                >{{ $t('marketing.objectives.priorities.priority.main_competitor') }}</span
              >
              <select
                v-model="tableData[2].competence"
                @change="changeOption()"
              >
                <option
                  v-for="item in competenceSelected"
                  :value="item.brand_id"
                  >{{ item.name }}</option
                >
              </select>
            </td>
          </tr>
          <tr>
            <td colspan="3" class="separator">
              {{ $t('marketing.objectives.priorities.priority.expected_results') }}
            </td>
          </tr>
          <tr>
            <td :class="{ hidden: obj1 == undefined }">
              <span class="cell-title">{{ $t('general.sales') }}</span>
              <input
                type="number"
                min="0"
                v-model="tableData[0].potencial.sales"
                @change="changeOption()"
              />
              <span v-if="obj1 != undefined">%</span>
            </td>
            <td :class="{ hidden: obj2 == undefined }">
              <span class="cell-title">{{ $t('general.sales') }}</span>
              <input
                type="number"
                min="0"
                v-model="tableData[1].potencial.sales"
                @change="changeOption()"
              />
              <span v-if="obj2 != undefined">%</span>
            </td>
            <td :class="{ hidden: obj3 == undefined }">
              <span class="cell-title">{{ $t('general.sales') }}</span>
              <input
                type="number"
                min="0"
                v-model="tableData[2].potencial.sales"
                @change="changeOption()"
              />
              <span v-if="obj3 != undefined">%</span>
            </td>
          </tr>
          <tr>
            <td :class="{ hidden: obj1 == undefined }">
              <span class="cell-title">{{ $t('marketing.objectives.priorities.priority.new_customers') }}</span>
              <input
                type="number"
                min="0"
                v-model="tableData[0].potencial.new"
                @change="changeOption()"
              />
              <span v-if="obj1 != undefined">%</span>
            </td>
            <td :class="{ hidden: obj2 == undefined }">
              <span class="cell-title">{{ $t('marketing.objectives.priorities.priority.new_customers') }}</span>
              <input
                type="number"
                min="0"
                v-model="tableData[1].potencial.new"
                @change="changeOption()"
              />
              <span v-if="obj2 != undefined">%</span>
            </td>
            <td :class="{ hidden: obj3 == undefined }">
              <span class="cell-title">{{ $t('marketing.objectives.priorities.priority.new_customers') }}</span>
              <input
                type="number"
                min="0"
                v-model="tableData[2].potencial.new"
                @change="changeOption()"
              />
              <span v-if="obj3 != undefined">%</span>
            </td>
          </tr>
        </tbody>
      </table>

      <div :class="{ hidden: !change }" @click="save()" class="save no-print">
        {{ $t('general.save_changes') }}
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  props: { categories: Object, objectives: Array },
  data() {
    return {
      change: false,
      tableData: [
        {
          name: "",
          daypart: { week: "", time: "" },
          behavior: "",
          competence: "",
          potencial: { sales: "", new: "" }
        },
        {
          name: "",
          daypart: { week: "", time: "" },
          behavior: "",
          competence: "",
          potencial: { sales: "", new: "" }
        },
        {
          name: "",
          daypart: { week: "", time: "" },
          behavior: "",
          competence: "",
          potencial: { sales: "", new: "" }
        }
      ],

      emptyTableData: [
        {
          name: "",
          daypart: { week: "", time: "" },
          behavior: "",
          competence: "",
          potencial: { sales: "", new: "" }
        },
        {
          name: "",
          daypart: { week: "", time: "" },
          behavior: "",
          competence: "",
          potencial: { sales: "", new: "" }
        },
        {
          name: "",
          daypart: { week: "", time: "" },
          behavior: "",
          competence: "",
          potencial: { sales: "", new: "" }
        }
      ],

      change: false,

      imgRoute:
        "img/marketing/2023_plan.jpg?3" +
        moment(new Date()).format("DD/MM/YYYY"),

      //This obj are used to asign te objectives at the first selectable part of the page
      obj1: undefined,
      obj2: undefined,
      obj3: undefined
    };
  },
  computed: {
    competenceSelected() {
      return this.$store.getters["locations/getCompetence"];
    },

    selectedLocation() {
      return this.$store.getters["locations/getSelectedLocation"];
    },

    selectedYear() {
      return this.$parent.selectedYear;
    },

    objectivesOptions() {
      return this.$store.getters["locations/getObjectives"];
    }
  },
  methods: {
    /* SELECTABLE */
    selectNacional(name, id, type) {
      var self = this;
      if (this.obj1 == id) {
        this.$popup.confirm(
          i18n.t('marketing.objectives.popup.title'),
          i18n.t('marketing.objectives.popup.message', { name: name }),
          i18n.t('general.continue'),
          i18n.t('general.cancel'),
          function() {
            self.obj1 = undefined;
            self.tableData[0].name = "";
            self.tableData[0].id = "";
            self.tableData[0].type = "";
            self.save();
          }
        );
      } else if (this.obj2 == id) {
        this.$popup.confirm(
          i18n.t('marketing.objectives.popup.title'),
          i18n.t('marketing.objectives.popup.message', { name: name }),
          i18n.t('general.continue'),
          i18n.t('general.cancel'),
          function() {
            self.obj2 = undefined;
            self.tableData[1].name = "";
            self.tableData[1].id = "";
            self.tableData[1].type = "";
            self.save();
          }
        );
      } else if (this.obj3 == id) {
        this.$popup.confirm(
          i18n.t('marketing.objectives.popup.title'),
          i18n.t('marketing.objectives.popup.message', { name: name }),
          i18n.t('general.continue'),
          i18n.t('general.cancel'),
          function() {
            self.obj3 = undefined;
            self.tableData[2].name = "";
            self.tableData[2].id = "";
            self.tableData[2].type = "";
            self.save();
          }
        );
      } else if (this.obj1 == undefined) {
        this.obj1 = id;
        this.tableData[0].name = name;
        this.tableData[0].id = id;
        this.tableData[0].type = type;
        this.change = true;
      } else if (this.obj2 == undefined) {
        this.obj2 = id;
        this.tableData[1].name = name;
        this.tableData[1].id = id;
        this.tableData[1].type = type;
        this.change = true;
      } else if (this.obj3 == undefined) {
        this.obj3 = id;
        this.tableData[2].name = name;
        this.tableData[2].id = id;
        this.tableData[2].type = type;
        this.change = true;
      } else {
        // this.$popup.alert("Focalizate solo en 2 prioridades estratégicas");
        this.$popup.alert(i18n.t('marketing.objectives.popup.alert'));
      }
    },

    // selectLocal(name, id) {
    //   var self = this;
    //   if ( this.obj3 == id ) {
    //     this.$popup.confirm(
    //     "Desmarcar prioridad local",
    //     "Toda la configuración definida para "+name+" se perderá. Siempre podras volverla a definir.",
    //     "Continuar",
    //     "Cancelar",
    //       function(){
    //         self.obj3 = undefined;
    //         self.tableData[2].name = "";
    //         self.tableData[2].id = "";
    //         self.save();
    //       }
    //     );
    //   }
    //   else if ( this.obj3 == undefined ) {
    //     this.obj3 = id;
    //     this.tableData[2].name = name;
    //     this.tableData[2].id = id;
    //     this.change = true;
    //   }
    //   else {
    //     this.$popup.alert("Focalizate solo en una oportunidad local");
    //   }
    // },

    /* TABLE */
    save() {
      var aData = {};
      var negativeNumber = false;
      for (var item in this.tableData) {
        if (
          this.tableData[item].potencial["sales"] == NaN ||
          this.tableData[item].potencial["sales"] < 0
        ) {
          negativeNumber = true;
        }
        if (
          this.tableData[item].potencial.new == NaN ||
          this.tableData[item].potencial.new < 0
        ) {
          negativeNumber = true;
        }
      }

      if (negativeNumber) {
        this.$popup.alert(
          i18n.t('marketing.objectives.popup.numeric_alert')
        );
      } else {
        aData.tableData = JSON.stringify(this.tableData);
        aData.restaurant_id = this.$store.getters[
          "locations/getSelectedLocation"
        ].id;
        aData.year = this.selectedYear;
        var self = this;
        this.$store
          .dispatch("locations/updateObjectives", aData)
          .then(function() {
            self.change = false;
            self.$store.dispatch("locations/loadMarketing", {
              restaurant_id:
                self.$store.getters["locations/getSelectedLocation"].id,
              year: self.selectedYear
            });
          });
      }
    },

    changeOption() {
      this.change = true;
    },

    getMarketingPhoto() {
      return (
        "https://lsm.mcdonalds.es/api/static/marketing/plan.jpg?" +
        moment(new Date()).format("DD/MM/YYYY")
      );
    },

    objectivesParsed() {
      /* This method loads objective table data */
      if (this.objectives[0] != undefined) {
        for (var index in this.objectives) {
          var item = this.objectives[index];
          if (this.objectives[index] != undefined) {
            this["obj" + item.status] = item.id;
            this.tableData[item.status - 1].name = item.name;
            this.tableData[item.status - 1].id = item.id;
            this.tableData[item.status - 1].daypart = JSON.parse(item.daypart);
            this.tableData[item.status - 1].behavior = item.comportament;
            this.tableData[item.status - 1].competence = item.competitor;
            this.tableData[item.status - 1].potencial = JSON.parse(item.value);
          }
        }
      } else {
        // If data is undefined, loads empty Array
        return (this.tableData = [
          {
            name: "",
            daypart: { week: "", time: "" },
            behavior: "",
            competence: "",
            potencial: { sales: "", new: "" }
          },
          {
            name: "",
            daypart: { week: "", time: "" },
            behavior: "",
            competence: "",
            potencial: { sales: "", new: "" }
          },
          {
            name: "",
            daypart: { week: "", time: "" },
            behavior: "",
            competence: "",
            potencial: { sales: "", new: "" }
          }
        ]);
      }
    }
  },
  watch: {
    selectedLocation() {
      this.change = false;
      if (this.selectedLocation == undefined) {
        this.$store.getters["locations/getSelectedLocation"];
      }
      this.$store.dispatch(
        "locations/loadCompetence",
        this.$store.getters["locations/getSelectedLocation"].id
      );
    },

    objectives() {
      var self = this;
      this.change = false;
      this.obj1 = undefined;
      this.obj2 = undefined;
      this.obj3 = undefined;
      this.objectivesParsed;
      this.$store
        .dispatch("locations/loadObjectives", this.selectedYear)
        .then(function() {
          self.objectivesParsed();
        });
    }
  },
  created() {
    var self = this;
    this.$store
      .dispatch("locations/loadObjectives", this.selectedYear)
      .then(function() {
        self.objectivesParsed();
      });
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.location-info {
  font-size: 15px;
  border: 1px solid #aaa;
  width: fit-content;
  padding: 5px 20px;
  margin: 20px auto;
  margin-top: 40px;

  .location-data {
    font-size: 17px;
    font-weight: bold;
    margin-left: 10px;
  }
}

.subtitle {
  background: var(--main_color);
  color: var(--dark_color);
  display: inline-block;
  text-align: center;
  font-size: 25px;
  font-family: Speedee-Bold;
  margin: 0;
  margin-top: 50px;
  padding: 0px 10px;
  z-index: 1;
}

.description {
  color: #999;
  margin: 20px 0px;
}

/* PRIORITY */
.cover {
  width: 70%;
  display: block;
  margin: 0 auto;
  /*margin-top: 40px;*/
}

.priority {
  width: 30%;
  display: inline-block;
  vertical-align: top;
  margin: 20px 50px;
  border-radius: 0px 0px 10px 10px;
  padding-bottom: 3px;

  .title {
    //background-color: #dadada;
    padding: 20px;
    border-bottom: 4px solid rgba(0, 0, 0, 0.1);

    .complement {
      display: block;
      font-size: 16px;
      margin-top: 10px;
    }
  }

  .option {
    border: 2px solid orange;
    background-color: #f9f9f9;
    width: calc(100% - 25px);
    padding: 7px 20px;
    margin: 10px auto;
    font-size: 15px;
    cursor: pointer;
    border-radius: 5px;

    //   &:hover, &.select3 {
    //     background-color: wheat;
    //     font-weight: bold;
    //   }

    //   &.select3 {
    //     &:before {
    //       content:'#3';
    //       background: white;
    //       border-radius: 10px;
    //       display: inline-block;
    //       float: left;
    //       width: 2rem;
    //       font-size: 15px;
    //       font-weight: bold;
    //       margin-right: 0.5rem;
    //       text-align: center;
    //     }
    //   }
    // }

    // &.national .option {
    border: 2px solid orange;

    &:hover,
    &.select1,
    &.select2,
    &.select3 {
      background-color: wheat;
    }

    &.select1 {
      &:before {
        content: "#1";
        background: white;
        border-radius: 10px;
        display: inline-block;
        float: left;
        width: 2rem;
        font-size: 15px;
        font-weight: bold;
        margin-right: 0.5rem;
        text-align: center;
      }
    }

    &.select2 {
      &:before {
        content: "#2";
        background: white;
        border-radius: 10px;
        display: inline-block;
        float: left;
        width: 2rem;
        font-size: 15px;
        font-weight: bold;
        margin-right: 0.5rem;
        text-align: center;
      }
    }

    &.select3 {
      &:before {
        content: "#3";
        background: white;
        border-radius: 10px;
        display: inline-block;
        float: left;
        width: 2rem;
        font-size: 15px;
        font-weight: bold;
        margin-right: 0.5rem;
        text-align: center;
      }
    }
  }
}

/* TABLE */
.objectives-table {
  margin: 10px auto;
  border-color: white;
  width: 80%;

  &.weekend {
    margin-top: 40px;
  }

  .hide {
    visibility: hidden !important;
    opacity: 0 !important;
  }

  thead {
    tr {
      th {
        width: 33%;
        background-color: transparent;
        border-bottom: 1px solid var(--main_color);
        height: 50px;
        text-transform: uppercase;
        padding: 10px 10px;

        .name {
          display: block;
          font-size: 16px;
          background-color: var(--main_color);
        }
      }
    }
  }

  tbody {
    //background-color: var(--main_color);
  }

  tr {
    //background-color: rgba(255,255,255,0.5);
    height: 50px;
  }

  tr:nth-child(odd) {
    //
  }

  td {
    text-transform: uppercase;
    font-weight: bold;
    padding: 20px 10px;
    text-align: center;
    border-bottom: 1px solid #ddd;
    background-color: rgba(255, 255, 255, 0.7);

    &:nth-child(2) {
      border-left: 1px solid #777;
      border-right: 1px solid #777;
    }

    &.hidden {
      background-color: #eee;

      select,
      input {
        display: none;
      }
    }

    .cell-title {
      display: block;
      font-weight: lighter;
      color: #666;
      font-size: 14px;
    }

    input {
      border-bottom: 1px solid black;
      text-align: right;
      width: 50px;
      padding: 6px;
    }

    select {
      padding: 6px;
      width: 100%;
      border: 1px solid #ddd;
      border-radius: 3px;
      margin: 5px 0;
    }

    &.separator {
      background: #eee;
      border-bottom: 2px solid #ffbb0c;
    }
  }
}

.save {
  background-color: #8bc34a;
  width: fit-content;
  margin: 0 auto;
  margin-top: 30px;
  color: white;
  padding: 8px 25px;
  border-radius: 3px;
  font-size: 16px;
  cursor: pointer;
  opacity: 1;
  transition: 0.5s;
  text-transform: uppercase;

  &.hidden {
    display: none;
    opacity: 0;
    height: 0px;
    transition: 0.5s;
  }
}
</style>
